import FormElementTypes from './../FormElementTypes'
import DateTimeParser   from './../parser/datetime-parser'

export default {

  /**
   *
   * @param formElement
   * @param value
   * @return {*}
   */
  convert (formElement, value) {
    if (formElement.type === FormElementTypes.dataType.datetime
      || formElement.type === FormElementTypes.dataType.datetimeinput
      || formElement.type === FormElementTypes.dataType.date
      || formElement.type === FormElementTypes.dataType.inputBox) {
      value = DateTimeParser.prettyDateToISO(value)
    }

    if (formElement.type === FormElementTypes.dataType.decimal0 ||
      formElement.type === FormElementTypes.dataType.decimal1 ||
      formElement.type === FormElementTypes.dataType.decimal2 ||
      formElement.type === FormElementTypes.dataType.decimal3 ||
      formElement.type === FormElementTypes.dataType.decimal4 ||
      formElement.type === FormElementTypes.dataType.decimal99 ||
      formElement.type === FormElementTypes.dataType.money) {
      if (typeof value === 'string' && value) {
        value = value.replace(/ /g, '')
        value = value.replace(',', '.')
        value = parseFloat(value)
      }
    }

    return value
  }

}
